import { useTranslation } from 'react-i18next'
import { useGymTimezone } from '../../contexts/GymContext'
import type { Subscription } from '../plans/types'

type PlanLineSource = Pick<Subscription, 'entries_remaining' | 'expires_at'> & {
  gym_plans?: { name: string } | null
}

/**
 * "Monthly unlimited · until 12.11.2026" or "10-entry pass · 3 entries
 * remaining": what the desk needs before letting someone in. Built from the
 * plan already loaded with the list, so it costs no request.
 */
export function usePlanLine(): (sub: PlanLineSource | null | undefined) => string | undefined {
  const { t, i18n } = useTranslation()
  const timezone = useGymTimezone()
  return (sub) => {
    if (!sub) return undefined
    const parts = [sub.gym_plans?.name].filter((p): p is string => Boolean(p))
    if (sub.entries_remaining !== null) {
      parts.push(t('scan.entriesRemaining', { count: sub.entries_remaining }))
    } else if (sub.expires_at) {
      parts.push(
        t('scan.planUntil', {
          date: new Date(sub.expires_at).toLocaleDateString(i18n.language, {
            timeZone: timezone ?? undefined,
          }),
        }),
      )
    }
    return parts.length > 0 ? parts.join(' · ') : undefined
  }
}
